import Vue from 'vue';
import Router from 'vue-router';
import Menu from './CommonFeature/templates/Menu.vue';
import UketsukeRouter from './Uketsuke/uketsuke-router';
import ItakuRouter from './Hyoutei/Itaku/ItakuRoutes';
import KanriRouter from './Kanri/kanri-router';
import UketsukeCustomRouter from './Uketsuke/custom/uketsuke-custom-routers';
import OrderLogin from './CommonFeature/templates/OrderLogin.vue';
import Logout from './CommonFeature/templates/Logout.vue';
import euc from './CommonFeature/templates/Euc.vue';
import eucUpload from './CommonFeature/templates/EucUpload.vue';
import changeMyPassword from './CommonFeature/templates/ChangeMyPassword.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/menu',
      name: 'menu',
      component: Menu,
    },
    {
      path: '/login',
      name: 'no_auth/OrderLogin',
      component: OrderLogin,
    },
    {
      path: '/logout',
      name: 'no_auth/logout',
      component: Logout,
    },
    {
      path: '/euc',
      name: 'euc',
      component: euc,
    },
    {
      path: '/eucUpload',
      name: 'eucUpload',
      component: eucUpload,
    },
    {
      path: '/changeMyPassword',
      name: 'no_auth/changeMyPassword',
      component: changeMyPassword,
    },
    { ...UketsukeRouter },
    { ...ItakuRouter },
    { ...KanriRouter },
    { ...UketsukeCustomRouter },
  ],
});
